// ==========================================================================
// NAV — On scroll down: hide; re-show on scroll up or hover near top
// ==========================================================================

export function initNav() {
  const nav = document.getElementById('nav');
  if (!nav) return;

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
  const MOUSE_THRESHOLD = 75;
  let hidden = false;
  let navHovered = false;

  const page = document.body.dataset.page;

  // Studio + press + legal: nav starts collapsed on desktop
  if (['studio', 'press', 'legal'].includes(page) && !isMobile()) {
    nav.classList.add('nav--scrolled');
    hidden = true;
  }

  function showNav() {
    if (hidden) {
      nav.classList.remove('nav--scrolled');
      hidden = false;
    }
  }

  function hideNav() {
    // Don't hide while the cover image is visible (project page phase 1)
    if (nav.classList.contains('nav--on-cover')) return;
    if (!hidden) {
      nav.classList.add('nav--scrolled');
      hidden = true;
    }
  }

  let lastScrollY = window.scrollY;

  // Scroll and hover behaviors disabled on mobile — menu opens via burger only
  window.addEventListener('scroll', () => {
    if (isMobile()) return;
    // Don't collapse while cursor is inside the nav — prevents oscillation
    if (navHovered) return;

    const currentScrollY = window.scrollY;

    if (currentScrollY <= 80) {
      showNav();
    } else if (currentScrollY > lastScrollY) {
      hideNav();   // scrolling down
    } else {
      showNav();   // scrolling up
    }

    lastScrollY = currentScrollY;
  }, { passive: true });

  // Hover peek near top of screen — only for non-contextual pages (press, legal, …).
  // Pages with contextual swap handle hover via contextual-nav.js nav mousemove.
  window.addEventListener('mousemove', (e) => {
    if (isMobile()) return;
    if (nav.classList.contains('nav--contextual-active')) return;
    if (e.clientY <= MOUSE_THRESHOLD) showNav();
  });

  nav.addEventListener('mouseenter', () => {
    if (isMobile()) return;
    navHovered = true;
    // On contextual-swap pages, peek is handled entirely by contextual-nav.js.
    // Calling showNav() here toggles nav--scrolled which triggers a CSS transition
    // that shifts the hit area and causes an immediate spurious mouseleave.
    if (nav.classList.contains('nav--has-contextual-swap')) return;
    showNav();
  });

  nav.addEventListener('mouseleave', () => {
    if (isMobile()) return;
    navHovered = false;
    if (nav.classList.contains('nav--has-contextual-swap')) return;
    if (window.scrollY > 80) hideNav();
  });

  // ── Dim sibling links on hover ───────────────────────────────────────────────
  // Left and right sides are treated as one group so hovering a link dims
  // all other links across both sides simultaneously.

  [
    ['.nav__left a', '.nav__right a'],   // standard nav
    ['.hn-left a',   '.hn-right a'],     // home nav
  ].forEach(selectors => {
    const links = [...document.querySelectorAll(selectors.join(', '))];
    if (links.length < 2) return;

    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        links.forEach(other => { if (other !== link) other.classList.add('nav-link--dim'); });
      });
      link.addEventListener('mouseleave', () => {
        links.forEach(other => other.classList.remove('nav-link--dim'));
      });
    });
  });
}
